<template>
	<form class="q_write" autocomplete="off" @submit.prevent>
		<div class="d_flex">
			<div class="mr_10">
				<label>{{ $t('input.label.email') }}</label>
				<input
					type="email"
					:placeholder="$t('input.placeholder.email')"
					class="mt_10 mb_20"
					v-model="emailAddress"
				/>
			</div>
			<div>
				<label>{{ $t('input.label.password') }}</label>
				<input
					type="password"
					:placeholder="$t('input.placeholder.password')"
					class="mt_10 mb_20"
					v-model="password"
				/>
			</div>
		</div>
		<label>{{ $t('input.label.inquiry_type') }}</label>
		<div class="select_wrap mt_10 mb_20">
			<select class="contact_type" v-model="typeSeq">
				<option value="" selected disabled>
					{{ $t('cs.placeholder.type') }}
				</option>
				<option
					v-for="item in ticketTypeList"
					:key="item.seq"
					:value="item.seq"
				>
					{{ item.title }}
				</option>
			</select>
		</div>
		<label>{{ $t('input.label.enter_subject') }}</label>
		<input
			type="text"
			:placeholder="$t('cs.placeholder.title')"
			class="mt_10 mb_20"
			v-model="title"
		/>
		<label>{{ $t('input.label.inquiry_content') }}</label>
		<textarea
			class="ask mt_10"
			:placeholder="$t('cs.placeholder.content')"
			v-model="content"
		></textarea>
		<div class="inquiry_button_area">
			<button class="mr_10">{{ $t('button.cancel') }}</button>
			<button class="button_bg_red" @click="registTicket">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</form>
	<!-- <div class="pin_container"> -->
	<!-- 모달시작 -->
	<ModalView
		v-if="pinCodeModal"
		@closeModal="pinCodeModal = false"
		add-class="inquiry tal"
	>
		<div>
			<h3 class="mb_10">{{ $t('cs.ticket.id') }}</h3>
			<p class="mb_20 fs_12 fc_gray_1">
				{{ $t('cs.ticket.text1') }}
			</p>
			<label class="pin_number" for="pin_number">
				<input
					v-model="ticketId"
					id="pin_number"
					type="text"
					readonly
					class="mb_50 tac" /><span
					class="copy_icon"
					@click="copyTicketId"
				></span
			></label>
			<div class="button_area">
				<button @click="pinCodeModal = false">
					{{ $t('button.cancel') }}
				</button>
				<button class="fc_red" @click="$emit('goList')">
					{{ $t('button.confirm') }}
				</button>
			</div>
		</div>
	</ModalView>
	<!-- 모달끝 -->
	<!-- </div> -->
</template>

<script>
import ModalView from '@/components/Layout/ModalView';
import { createTicket, fetchTicketTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';
import useClipboard from 'vue-clipboard3';

export default {
	name: 'Inquiry',
	components: { ModalView },
	emits: ['goList'],
	data() {
		return {
			emailAddress: '',
			password: '',
			parentSeq: '',
			typeSeq: '',
			title: '',
			content: '',
			fieldValues: [],
			ticketTypeList: [],
			ticketId: '',
			pinCodeModal: false,
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadTicketTypeList();
		},
		async loadTicketTypeList() {
			const { data } = await fetchTicketTypes().catch(commonError);
			this.ticketTypeList = data.filter(item => {
				return item.allow_guest === 'Y';
			});
		},
		async registTicket() {
			const params = {
				parent_seq: this.parentSeq,
				type_seq: this.typeSeq,
				title: this.title,
				content: this.content,
				email_address: this.emailAddress,
				password: this.password,
				field_values: this.fieldValues,
			};
			await createTicket(params)
				.then(result => {
					this.ticketId = result.ticket_id;
					this.pinCodeModal = true;
				})
				.catch(commonError);
		},
		copyTicketId() {
			try {
				useClipboard().toClipboard(this.ticketId);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
	},
};
</script>

<style scoped>
.pin_number {
	position: relative;
}
.copy_icon {
	position: absolute;
	display: block;
	top: 50%;
	transform: translateY(-50%);
	right: 15px;
	width: 16px;
	height: 16px;
	background: url('~@/assets/images/icon/copy.png') no-repeat;
	background-size: cover;
	cursor: pointer;
}
.rtr_cs .fc_gray_1 {
	color: #919191;
}
</style>
